import { getCourseFilter, postCourseList } from 'src/services/course/list'
import {
  setLoadMore,
  startLoadMore,
  stopLoadMore,
} from 'src/redux/slices/course/list'
import { startLoading, stopLoading } from 'src/redux/slices/loading'
import { isScrolledIntoElement } from 'src/utils/lib'

export const fetchCourseFilter = () => async (dispatch) => {
  await dispatch(getCourseFilter())
}

export const fetchCourseList = (body) => async (dispatch) => {
  dispatch(startLoading())
  try {
    await dispatch(postCourseList(body))
  } catch (error) {
    console.log(error)
  }
  dispatch(stopLoading())
}

export const handleLoadMore = () => (dispatch) => {
  const footer = document.getElementById('page-footer')
  const isFooterAppeared = isScrolledIntoElement(footer)
  if (isFooterAppeared) dispatch(setLoadMore())
}

export const handleSeeMore = (filterBody) => async (dispatch) => {
  if (filterBody.page == 1) return

  dispatch(startLoadMore())
  await dispatch(postCourseList(filterBody))
  dispatch(stopLoadMore())
}
